// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"79":"8c13747b","359":"96f3affa","405":"70580b2f","641":"e6bf232c","715":"a5a13085","933":"fc971ed4"}[chunkId] + ".js";
};